import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ShoppingBagIcon } from 'lucide-react';
import { useCart } from '../CartContext';
export function Navbar() {
  const {
    totalItems
  } = useCart();
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/';
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <header className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white/80 backdrop-blur-xl border-b border-gray-100 shadow-sm' : 'bg-transparent'}`} data-id="element-293" data-mp="1kzzpg7rbpueo">
      <nav className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4 md:px-10" data-id="element-294" data-mp="enke0a6t63k6">
        <Link to="/" className="flex items-center" data-id="element-295" data-mp="jmnk7xyiyftq">
          <span className="font-display text-2xl font-medium tracking-tight text-gray-900" data-id="element-296" data-mp="jnym1s8etdi7">Smaken.</span>
        </Link>

        <ul className="hidden items-center gap-8 text-sm font-medium text-gray-600 md:flex" data-id="element-297" data-mp="okysw5d32kad">
          <li data-id="element-298" data-mp="3n57349vbc9bv"><Link to="/utbud" className="transition-colors hover:text-gray-900" data-id="element-299" data-mp="3n571k5fo019r">Vårt utbud</Link></li>
          <li data-id="element-300" data-mp="3s2ql9kv4t693"><a href="/#verksamheter" className="transition-colors hover:text-gray-900" data-id="element-301" data-mp="3s0cp18optnzy">Partners</a></li>
          <li data-id="element-302" data-mp="u2weuxon0ws"><Link to="/vision" className="transition-colors hover:text-gray-900" data-id="element-303" data-mp="ub9amtt267z">Vision</Link></li>
        </ul>

        <div className="flex items-center gap-4" data-id="element-304" data-mp="34cw6gxr957m7">
          <Link to="/bestall" className="relative flex h-10 w-10 items-center justify-center rounded-full bg-gray-50 text-gray-900 transition-colors hover:bg-gray-100" data-id="element-305" data-mp="34c36qgqpnidk">
            <ShoppingBagIcon className="h-4 w-4" data-id="element-306" data-mp="319yny9xdrg7p" />
            {totalItems > 0 && <span className="absolute -right-1 -top-1 flex h-4 w-4 items-center justify-center rounded-full bg-black text-[10px] font-bold text-white" data-id="element-307" data-mp="2wb5dyrhay7ca">
                {totalItems}
              </span>}
          </Link>
          <Link to="/bestall" className="hidden rounded-full bg-black px-5 py-2.5 text-sm font-medium text-white transition-transform hover:scale-105 md:block" data-id="element-308" data-mp="3642yt49ro8e2">
            Gör förfrågan
          </Link>
        </div>
      </nav>
    </header>;
}